var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"display":"flex","flex-direction":"row","align-items":"center","color":"#0F1A3A","font-size":"12px","font-weight":"bold"}},[_c('kl-icon',{attrs:{"size":20,"icon":_vm.icon}}),_c('div',{staticStyle:{"margin-left":"7px"}},[_vm._v(_vm._s(_vm.title))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }